/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Privacy_DescInputs */

const en_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy controls, consent settings, and AI-processing details are documented in the Privacy Policy.`)
};

const de_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzeinstellungen, Einwilligungsoptionen und KI-Verarbeitungsdetails sind in der Datenschutzerklaerung (/privacy) dokumentiert.`)
};

const fr_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les paramètres de confidentialité, les options de consentement et les détails du traitement IA sont documentés dans la Politique de confidentialité (/privacy).`)
};

const es_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los ajustes de privacidad, las opciones de consentimiento y los detalles del procesamiento de IA están documentados en la Política de privacidad (/privacy).`)
};

const it_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le impostazioni sulla privacy, le opzioni di consenso e i dettagli sull'elaborazione IA sono documentati nell'Informativa sulla privacy (/privacy).`)
};

const nl_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-instellingen, toestemmingsopties en AI-verwerkingsdetails zijn gedocumenteerd in het Privacybeleid (/privacy).`)
};

const pl_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia prywatnosci, opcje zgody i szczegoly przetwarzania AI sa udokumentowane w Polityce prywatnosci (/privacy).`)
};

const fi_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyysasetukset, suostumusvaihtoehdot ja tekoalykasittelyn tiedot on dokumentoitu tietosuojakaytannossa (/privacy).`)
};

const da_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivsindstillinger, samtykkevalg og AI-behandlingsdetaljer er dokumenteret i fortrolighedspolitikken (/privacy).`)
};

const sv_landing_feature_privacy_desc = /** @type {(inputs: Landing_Feature_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetsinstallningar, alternativ foer samtycke och detaljer om AI-behandling aer dokumenterade i integritetspolicyn (/privacy).`)
};

/**
* | output |
* | --- |
* | "Privacy controls, consent settings, and AI-processing details are documented in the Privacy Policy." |
*
* @param {Landing_Feature_Privacy_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_privacy_desc = /** @type {((inputs?: Landing_Feature_Privacy_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Privacy_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_privacy_desc(inputs)
	if (locale === "fr") return fr_landing_feature_privacy_desc(inputs)
	if (locale === "es") return es_landing_feature_privacy_desc(inputs)
	if (locale === "it") return it_landing_feature_privacy_desc(inputs)
	if (locale === "nl") return nl_landing_feature_privacy_desc(inputs)
	if (locale === "pl") return pl_landing_feature_privacy_desc(inputs)
	if (locale === "fi") return fi_landing_feature_privacy_desc(inputs)
	if (locale === "da") return da_landing_feature_privacy_desc(inputs)
	if (locale === "sv") return sv_landing_feature_privacy_desc(inputs)
	return en_landing_feature_privacy_desc(inputs)
});